<script setup lang="ts">
    type Option = {
        label: string;
        value: string;
    };

    interface Props {
        options: Option[];
        selected: string;
    }

    defineProps<Props>();

    const emit = defineEmits<{
        (e: 'select', value: string): void;
    }>();
</script>

<template>
    <div class="inline-block">
        <div class="flex flex-row bg-gray-dark rounded-xl p-2">
            <button
                v-for="option in options"
                :key="option.value"
                class="py-2 px-8 flex rounded-lg justify-center items-center cursor-pointer text-body"
                :class="
                    selected === option.value ? 'bg-gray-lightest text-gray-dark' : 'text-white'
                "
                :aria-label="option.label"
                @click="emit('select', option.value)"
            >
                {{ option.label }}
            </button>
        </div>
    </div>
</template>
